module.exports = __webpack_public_path__ + "static/media/person.9eea5577.svg";